export default {
  title: "Myeuroservice",
  version: "1.0.3"
};
